import type { FC } from "react";

import { INPUT_DEFAULTS, TInputProps } from "./Input.config";
import { InputField } from "./InputField";
import { FieldWrapper } from "../shared";

export const Input: FC<TInputProps> = (
  {
    label,
    type = INPUT_DEFAULTS.type,
    disabled,
    value,
    className,
    error,
    ...props
  },
) => {

  return (
    <FieldWrapper
      componentName="Input"
      className={className}
      disabled={disabled}
      error={error}
      label={label}
    >
      <InputField
        {...props}
        type={type}
        value={value}
        disabled={disabled}
        error={error}
      />
    </FieldWrapper>
  );
};

Input.displayName = "Input";
